"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileGame = exports.DesktopGame = void 0;
var DesktopGame_1 = require("./layouts/desktop/DesktopGame");
Object.defineProperty(exports, "DesktopGame", { enumerable: true, get: function () { return DesktopGame_1.DesktopGame; } });
var MobileGame_1 = require("./layouts/mobile/MobileGame");
Object.defineProperty(exports, "MobileGame", { enumerable: true, get: function () { return MobileGame_1.MobileGame; } });
